import React from 'react'
import { Box } from '@chakra-ui/react';

const ReportsJB = ({ content }) => {
    return (
        <Box>
            {content}
        </Box>
    )
}

export default ReportsJB